export default "__VITE_ASSET__nQ93khJ3__"